import { resolveStepFromPrerequisites, resolveStepFromPath } from './utils';
import { evaluateMerchantsData } from './merchantData.utils';

export const initFlow = allProps => {
  const { flowConfig, ...props } = allProps;

  const flow = {
    ...flowConfig,
    steps: flowConfig.steps.filter(step => step.exclude !== true),
  };

  const currentStepAccordingToPath = resolveStepFromPath(flow, props);

  const stepFromPrerequisites = resolveStepFromPrerequisites(
    flow,
    props,
    currentStepAccordingToPath,
  );

  const step = evaluateMerchantsData(stepFromPrerequisites, flow, props);

  if (currentStepAccordingToPath.id !== step.id || step.isFallback) {
    props.history.push(`${props.basePath}/${step.path}${props.history.location.search}`);
  }

  return flow;
};
